import SyncConstant from "../../constant/SyncConstant";
import ActionLogService from "../../../service/sync/ActionLogService";
import Config from "../../../config/Config";
import ActionLogAction from "../../action/ActionLogAction";

/**
 * Sync data action log
 * @param action$
 * @returns {*}
 */
export default function syncActionLog(action$) {
    return action$.ofType(SyncConstant.SYNC_ACTION_LOG)
        .switchMap(async function(action) {
            const onlyActionTypes = action.onlyActionTypes || null;
            if (window.navigator.onLine) {
                if (Config.isSyncingActionLog === SyncConstant.NOT_SYNCING_ACTION_LOG) {
                    try {
                        if (Config.syncActionLogFirstLoad) {
                            await ActionLogService.resetActionsStatus();
                            Config.syncActionLogFirstLoad = false;
                        }

                        ActionLogService.saveIsSyncingActionLog(SyncConstant.SYNCING_ACTION_LOG);
                        const syncOptions = onlyActionTypes && onlyActionTypes.length
                            ? { onlyActionTypes }
                            : {};
                        const { processedCount = 0 } = await ActionLogService.syncActionLog(syncOptions) || {};
                        let data = await ActionLogService.getAllDataActionLog();
                        if (data.some(item => item.status === SyncConstant.STATUS_REQUESTING)) {
                            return {type: "[SYNC] EMPTY"};
                        }

                        if (data.some(item => item.status === SyncConstant.STATUS_PENDING)) {
                            ActionLogService.saveIsSyncingActionLog(SyncConstant.NOT_SYNCING_ACTION_LOG);
                            // If nothing was processed, stop retry loop to avoid runaway memory usage
                            if (!processedCount) {
                                return ActionLogAction.syncActionLogSuccess();
                            }
                            // Scoped sync (e.g. customer only): do not chain into full queue — avoids place_order storm
                            if (onlyActionTypes && onlyActionTypes.length) {
                                return ActionLogAction.syncActionLogSuccess();
                            }
                            return ActionLogAction.syncActionLog();
                        }
                    } catch (e) {
                        return ActionLogAction.syncActionLogSuccess();
                    }
                }
            }
            return ActionLogAction.syncActionLogSuccess();
        });

}


// WEBPACK FOOTER //
// ./src/view/epic/sync/SyncActionLogEpic.js